import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/examTest2021/Index.vue')

export const examTest2021Route: RouteConfig = {
  path: '/exam-test-2021',
  name: 'examTest2021Route',
  component: Index,
  meta: {
    title: '中考活动',
  },
}

export default [examTest2021Route]
